/**
 * PATH: apps/qa/src/components/camera-capture/LocationIndicator.tsx
 * PURPOSE: GPS status badge showing accuracy level
 */

import { MapPin, MapPinOff, Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { GeolocationState } from './types'

export function LocationIndicator({ geo }: { geo: GeolocationState }) {
  const accuracyLabel = geo.accuracy
    ? geo.accuracy < 10 ? 'High' : geo.accuracy < 50 ? 'Medium' : 'Low'
    : null

  return (
    <div className={cn(
      'flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium',
      geo.status === 'granted' && 'bg-emerald-100 text-emerald-700',
      geo.status === 'denied' && 'bg-red-100 text-red-700',
      geo.status === 'requesting' && 'bg-amber-100 text-amber-700',
      geo.status === 'unavailable' && 'bg-slate-100 text-slate-600',
      geo.status === 'unknown' && 'bg-slate-100 text-slate-600'
    )}>
      {geo.status === 'granted' ? (
        <>
          <MapPin className="w-3 h-3" />
          {accuracyLabel} ({Math.round(geo.accuracy || 0)}m)
        </>
      ) : geo.status === 'denied' ? (
        <>
          <MapPinOff className="w-3 h-3" />
          GPS Denied
        </>
      ) : geo.status === 'requesting' ? (
        <>
          <Loader2 className="w-3 h-3 animate-spin" />
          Getting GPS...
        </>
      ) : (
        <>
          <MapPinOff className="w-3 h-3" />
          No GPS
        </>
      )}
    </div>
  )
}
